import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { isEmpty, startCase } from "lodash";
import LiveMatchTrackerCricket from "../../Score/Cricket/ScoerBoardDetail";
import SkyLayout from "../SkyLayout";
import SportbookSky from "./SportbookSky";
import BookPositionSky from "./BookPositionSky";
import ReactPlayer from "react-player";
import LoadingImage from "../../../assets/images/cover-live.webp";
import SelectionSky from "./SelectionSky";
import FancySky from "./FancySky";
import BookmakerSky from "./BookmakerSky";
import { useMatchDetailLogic } from "../../useLogic/useMatchDetailLogic";
import { IoVolumeHighSharp, IoVolumeMuteSharp } from "react-icons/io5";
const DetailSky = () => {
  const parmas = useParams();
  const ref = useRef(null);
  const {
    // context
    user,
    profileData,
    showBetDialog,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setMute,
    setFancyModal,
    loading,
    setLoading,
    mute,
    setTvClass,
    fancyTab,
    setFancyTab,
    marketNew,
    marketName,
    setMarketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,
    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,
    runner,
    setRunner,
    fancyHeader,
    favouriteList,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,
    showFancy,
    showSportbook,

    tv,
    getMatchDetails,
  } = useMatchDetailLogic();

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      // Check if scroll is past 200px and page height > 1200
      if (showBetDialog) {
        setTvClass(false);
        // setActiveTab("scoreboard");
      } else {
        if (scrollY >= 130 && pageHeight > 1000) {
          setTvClass(true);
        } else {
          setTvClass(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Initial check in case user is already scrolled
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showBetDialog]);
  const displayScore = () => {
    return detail?.eventId && detail?.eventId.toString().startsWith("-1") ? (
      // <LiveMatchTrackerCricket type="inner" scoreId={detail?.scoreId} />
      <iframe
        className="w-full aspect-video relative"
        style={{
          overflow: "hidden",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
          width:`100%`
        }}
        id="scoreId"
        src={detail?.scoreURL}
      ></iframe>
    ) : (
      <iframe
        className="w-full aspect-video relative"
        style={{
          overflow: "hidden",
          height: detail?.screenScore === "full" ? "270px" : "141px",
          backgroundColor: "#000000",
          width:`100%`
        }}
        id="scoreId"
        src={detail?.scoreURL}
      ></iframe>
    );
  };

  return (
    <SkyLayout>
      <div id="mainWrap" className="mian-wrap">
        <div className="game-wrap">
          <h4 id="gameInfo" className="game-info">
            {startCase(detail?.gameType)}
            <ul id="infoIcon" className="info-icon">
              {detail?.status == "in_play" && (
                <li id="inPlayIcon">
                  <img
                    className="info-inplay"
                    src={require("../../../assets/images/transparent.gif")}
                  />
                  In-Play
                </li>
              )}
              {/* <li style={{ display: "none" }}>
                <img
                  className="info-cashout"
                  src={require("../../../assets/images/transparent.gif")}
                />
                Cash Out
              </li> */}
              {/* <li id="fancyBetIcon" style={{ display: "none" }}>
                <span className="game-fancy">Fancy</span>
              </li>
              <li id="bookMakerIcon" style={{ display: "none" }}>
                <span className="game-bookmaker">BookMaker</span>
              </li>
              <li id="feedingSiteIcon" style={{ display: "none" }}>
                <span className="game-sportsbook">Sportsbook</span>
              </li>
              <li>
                <span
                  id="lowLiquidityTag"
                  className="game-low_liq"
                  style={{ display: "none" }}
                >
                  Low
                </span>
              </li> */}
            </ul>
          </h4>
          {/* <table
            id="gameTeam"
            className="game-team "
            style={{ display: "none" }}
          >
            <tbody>
              <tr>
                <th>
                  <a id="multiMarketPin" className="pin-off" href="#" />
                  <h4 id="teamHome" />
                  <h4 id="teamAway" />
                  <ul id="time" className="scores-time">
                    <li>15 Sep, 17:30</li>
                  </ul>
                </th>
                <td className="team-refresh">
                  <a id="refresh" className="refresh" href="#" />
                </td>
              </tr>
            </tbody>
          </table> */}

          <div id="matchTrackerWrap" className="match-tracker-wrap">
            {
            !isEmpty(user) &&
            detail?.status == "in_play" ? (
              <div className="tv-fix" id="streamingBox">
                <div className="tv-box">
                  <div data-v-4500b3c2 className="video-wrapper relative z-0">
                    {loading && (
                      <img
                        src={LoadingImage}
                        alt="Thumbnail"
                        className="w-full aspect-video relative"
                        width={"100%"}
                        style={{
                          padding: "0",
                          position: "absolute",
                          margin: "0",
                          width: "100%",
                        }}
                      />
                    )}
                    {!loading && (
                      <>
                        {mute ? (
                          <IoVolumeMuteSharp
                            onClick={() => setMute(!mute)}
                            style={{
                              position: "absolute",
                              right: "5%",
                              zIndex: "99999",
                              bottom: "6%",
                            }}
                            size={20}
                            color="white"
                          />
                        ) : (
                          <IoVolumeHighSharp
                            onClick={() => setMute(!mute)}
                            style={{
                              position: "absolute",
                              right: "5%",
                              zIndex: "99999",
                              bottom: "6%",
                            }}
                            size={20}
                            color="white"
                          />
                        )}{" "}
                      </>
                    )}
                    <ReactPlayer
                      muted={mute}
                      controls={false}
                      ref={ref}
                      playsinline={true}
                      loop={true}
                      playing={true}
                      id="videoFrame"
                      className="s-w-full s-aspect-video s-relative s-z-0"
                      onReady={() => setLoading(false)} // Video is ready → hide loader
                      onBuffer={() => setLoading(true)} // When buffering → show loader
                      onBufferEnd={() => setLoading(false)} // Buffer ends → hide loader
                       width={`100%`}
                      height="100%"
                      url={`https://cceucceu.cc/${detail.channel}/index.m3u8`}
                      config={{
                        youtube: {
                          playerVars: {
                            showinfo: 1,
                            fs: 1,
                            controls: 1,
                          },
                        },

                        file: {
                          attributes: {
                            preload: "none",
                            crossOrigin: "true",
                          },
                          hlsOptions: {
                            startLevel: 3,
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {!["horse", "greyhound"].includes(parmas?.type) &&
              !isEmpty(detail?.scoreId) &&
              detail?.scoreId != "false" &&
              displayScore()}
            <ul className="match-btn">
              <li>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    addToFavioute(
                      detail?.eventId,
                      "Match Odds",
                      marketId,
                      marketName
                    );
                  }}
                  id="liveMultiMarketPin"
                  style={{ cursor: "pointer" }}
                  name="gameHeadPin"
                  className={`btn-pin btn-match-new ${
                    !isEmpty(
                      detail?.favourites?.find((obj) => {
                        return marketId == obj?.favoriteMarketId;
                      })
                    )
                      ? "select"
                      : ""
                  }`}
                  title="Add to Multi Markets"
                >
                  Pin
                </div>
              </li>
              <li>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    getMatchDetails();
                  }}
                  style={{ cursor: "pointer" }}
                  className="btn-refresh btn-match-new "
                >
                  Refresh
                </div>
              </li>
            </ul>
          </div>
        </div>
        {marketNew?.length > 0 && detail?.matchOdds == "on" && (
          <div id="naviMarket" className="market-type ps ps--theme_default">
            <ul id="naviMarketList">
              {marketNew?.map((res, index) => {
                return (
                  <li
                    onClick={(e) => {
                      {
                        setMarketName(res?.market);
                        getMatchOdds(res?.marketId);
                        getBetPosition(res?.marketId);
                        setRunner(res?.jsonData);
                        setMarketId(res?.marketId);
                      }
                    }}
                    style={{ display: "list-item" }}
                    className={marketName == res?.market ? "select" : ""}
                  >
                    <div className="navimarket-li">{res?.market}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {detail?.matchOdds == "on" && runner?.length > 0 && (
          <SelectionSky
            runner={runner}
            name={marketName}
            marketId={marketId}
            totalMatched={totalMatched}
            backOdds={backOdds}
            layOdds={layOdds}
            oldBack={oldBack}
            oldLay={oldLay}
            detail={detail}
            ms={ms}
            position={positionMemo}
            profileData={profileDataMemo}
            typeGame="betFaire"
            marketName={marketName}
            user={user}
            addToFavioute={addToFavioute}
          />
        )}
        {detail?.bookMaker == "on" &&
          (detail?.gameType == "cricket" || detail?.hasBookmaker) &&
          bookmaker?.length > 0 && (
            <BookmakerSky
              runner={bookmaker}
              marketId={parmas?.marketId}
              detail={detail}
              backOdds={backOddsBookmaker}
              layOdds={layOddsBookmaker}
              oldBack={oldBackBookmaker}
              oldLay={oldLayBookmaker}
              ms={detail?.bookMaker == "on" ? bookmakerOdds?.ms : 3}
              position={positionMemoBookmaker}
              profileData={profileDataMemo}
              addToFavioute={addToFavioute}
              typeGame="bookmaker"
              marketName={"Bookmaker"}
              user={user}
            />
          )}
        {fancyTab == "Fancy" && (
          <div id="fancyBetTable_34726583" name="multiMarketItem">
            <div id="fancyBetHead" className="fancy_bet-head">
              <h4 onClick={() => setFancyTab("Fancy")} className="in-play">
                <div id="multiMarketPin" className="pin-off">
                  Pin to Muilti Markets
                </div>
                <span>
                  <pre>in-play</pre>Fancy Bet
                </span>
                <div
                  className="btn-head_rules"
                  onclick="javascript: $j('#fancyBetRulesWrap').fadeIn().css('display', 'flex');"
                >
                  Rules
                </div>
              </h4>
              {showSportbook && (
                <div
                  onClick={() => setFancyTab("Premium")}
                  id="showSportsBookBtn"
                  className="other-tab"
                >
                  <span className="tag-new">New</span>
                  Premium Cricket
                </div>
              )}
            </div>
            {parmas?.type != "multi" &&
              !["Winner", "Win"].includes(detail?.market) &&
              detail?.gameType == "cricket" &&
              detail?.hasFancy && (
                <FancySky
                  fancy={fancy}
                  detail={detail}
                  fancyHeader={fancyHeader}
                  position={fancyPosition}
                  typeGame={"fancy"}
                  profileData={
                    detail?.matchSetting?.length > 0
                      ? {
                          ...detail,
                          arrayCheck: "details",
                          profile: profileData,
                        }
                      : {
                          ...profileData,
                          arrayCheck: "profile",
                          profile: profileData,
                        }
                  }
                  setFancyModal={setFancyModal}
                  addToFavioute={addToFavioute}
                  favouriteList={favouriteList}
                />
              )}
          </div>
        )}

        {fancyTab == "Premium" &&
          (detail?.premiumFancy == "on" || detail?.hasSportBook) &&
          !isEmpty(user) && (
            <div id="sportsBookWrap" style={{ display: "block" }}>
              <div id="sportsBookHead" className="sportsbook_bet-head">
                <h4 onClick={() => setFancyTab("Premium")} id="betHeader">
                  <span id="sportsBookName">Premium Cricket</span>
                  <div id="sportsBookRules" className="btn-head_rules">
                    Rules
                  </div>
                </h4>
                {showFancy && (
                  <div
                    onClick={() => setFancyTab("Fancy")}
                    id="showFancyBetBtn"
                    className="other-tab"
                  >
                    Fancy Bet
                  </div>
                )}
              </div>
              {(parmas?.type == "multi" ? true : fancyTab == "Premium") &&
                (detail?.premiumFancy == "on" || detail?.hasSportBook) && (
                  <SportbookSky
                    data={sportsBook}
                    user={user}
                    favouriteList={favouriteList}
                    detail={detail}
                    position={sportsBookPosition}
                    setBetSlipObject={setBetSlipObject}
                    betSlipObject={betSlipObject}
                    profileData={
                      detail?.matchSetting?.length > 0
                        ? {
                            ...detail,
                            arrayCheck: "details",
                          }
                        : {
                            ...profileData,
                            arrayCheck: "profile",
                          }
                    }
                    addToFavioute={addToFavioute}
                  />
                )}
            </div>
          )}
        {!isEmpty(fancyModal?.object) && fancyModal?.status && (
          <BookPositionSky
            object={fancyModal?.object}
            setFancyModal={setFancyModal}
          />
        )}
      </div>
    </SkyLayout>
  );
};

export default DetailSky;
